// „Optionen“ des Boards (wie in Close): nur aktive Status oder alle, und was zusätzlich auf der Karte steht.
import { useState } from "react";
import { Ausklapp } from "../components/Ausklapp";
import { Icon } from "../components/Icon";
import type { KartenOptionen } from "./Karte";

interface Props {
  nurAktive: boolean;
  onNurAktive: (an: boolean) => void;
  optionen: KartenOptionen;
  onOptionen: (o: KartenOptionen) => void;
}

const ZEILEN: { key: keyof KartenOptionen; label: string }[] = [
  { key: "leadStatus", label: "Lead-Status" },
  { key: "kontakt", label: "Kontakt" },
  { key: "notiz", label: "Notiz" },
];

export function OptionenKnopf({ nurAktive, onNurAktive, optionen, onOptionen }: Props) {
  const [offen, setOffen] = useState(false);
  const [knopf, setKnopf] = useState<HTMLButtonElement | null>(null);
  return (
    <>
      <button ref={setKnopf} type="button" className="knopf knopf--klein" aria-haspopup="dialog" aria-expanded={offen} title="Anzeige des Boards" onClick={() => setOffen((o) => !o)}>
        <Icon name="felder" groesse={14} />
        Optionen
      </button>
      <Ausklapp anker={knopf} offen={offen} onSchliessen={() => setOffen(false)} breite={260} ausrichtung="end" rolle="dialog">
        <div className="opp-optionen">
          <div className="opp-optionen__titel">Status</div>
          <div className="segment" role="group" aria-label="Welche Status das Board zeigt">
            <button type="button" className={`segment__knopf${nurAktive ? " segment__knopf--an" : ""}`} onClick={() => onNurAktive(true)}>
              Nur aktive
            </button>
            <button type="button" className={`segment__knopf${!nurAktive ? " segment__knopf--an" : ""}`} onClick={() => onNurAktive(false)}>
              Alle
            </button>
          </div>
          <div className="opp-optionen__titel">Auf der Karte zeigen</div>
          {ZEILEN.map((z) => (
            <label key={z.key} className="opp-optionen__zeile">
              <input type="checkbox" checked={optionen[z.key]} onChange={(e) => onOptionen({ ...optionen, [z.key]: e.target.checked })} />
              <span>{z.label}</span>
            </label>
          ))}
        </div>
      </Ausklapp>
    </>
  );
}
